import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ShiftAccessRightConfirmationModalResult } from '../shift-access-right-confirmation-modal/shift-access-right-confirmation-modal.component';

@Component({
  selector: 'wilson-bulk-shift-access-right-confirmation-modal',
  imports: [NzModalModule, TranslateModule, NzTooltipModule, NzButtonModule],
  templateUrl: './bulk-shift-access-right-confirmation-modal.component.html',
  styleUrls: ['./bulk-shift-access-right-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkShiftAccessRightConfirmationModalComponent {
  private modalRef = inject(NzModalRef);

  handleCancel(): void {
    this.modalRef.destroy(null);
  }

  handleProceedAnyway(): void {
    this.modalRef.destroy(
      ShiftAccessRightConfirmationModalResult.ProceedAnyway,
    );
  }

  handleUpdateShifts(): void {
    this.modalRef.destroy(ShiftAccessRightConfirmationModalResult.UpdateShift);
  }
}
